import { render, staticRenderFns } from "./UserCardRoles.vue?vue&type=template&id=ddfa80f6&"
import script from "./UserCardRoles.vue?vue&type=script&lang=ts&"
export * from "./UserCardRoles.vue?vue&type=script&lang=ts&"
import style0 from "./UserCardRoles.vue?vue&type=style&index=0&id=ddfa80f6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports